import type { DashboardRowType } from '@shared/types/Dashboard';

export const homeCircleDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 12,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 20,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 15,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 11,
      },
    ],
  },
];
